export default __webpack_public_path__ + "static/media/stormnimbus.5fe9fbc4.png";